import React from 'react';
import dynamic from 'next/dynamic';
import HeaderLogo from 'components/commercetools-ui/organisms/header/header-logo';
import HeaderNavigationDesktop from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-desktop';
import HeaderNavigationMobile from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-mobile';
import { HeaderProps } from 'components/commercetools-ui/organisms/header/types';
import UtilitySection from 'components/commercetools-ui/organisms/header/utility-section';

const AlgoliaSearch = dynamic(() => import('components/commercetools-ui/atoms/search-algolia'));
const CommercetoolsSearch = dynamic(() => import('components/commercetools-ui/atoms/search'));

const Header: React.FC<HeaderProps> = ({
  cart,
  isEmpty,
  onRemoveDiscountCode,
  onApplyDiscountCode,
  totalCartItems,
  totalWishlistItems,
  onRemoveItem,
  onUpdateItem,
  OnMoveToWishlist,
  wishlist,
  onMoveToCart,
  onRemoveFromWishlist,
  onClearWishlist,
  navLinks,
  categories,
  logo,
  logoMobile,
  logoLink,
  logoLinkMobile,
  tiles,
  searchItems,
  onSearchQueryUpdate,
  emptyCartTitle,
  emptyCartSubtitle,
  emptyCartImage,
  emptyCartCategories,
  emptyWishlistTitle,
  emptyWishlistSubtitle,
  emptyWishlistImage,
  emptyWishlistCategories,
  enableAlgoliaSearch = false,
}) => {
  const Search = enableAlgoliaSearch ? AlgoliaSearch : CommercetoolsSearch;

  return (
    <header className="relative h-fit w-full border-b-[1.5px] border-neutral-400 bg-white">
      <div
        aria-label="Top"
        className="flex w-full items-center justify-between px-16 md:px-24 lg:px-20 xl:grid xl:grid-cols-[1fr_auto_1fr] xl:items-center xl:px-48"
      >
        {/* Izquierda: menú móvil (mobile/tablet) o navegación desktop (xl) */}
        <div className="flex min-w-0 flex-1 items-center justify-start">
          <HeaderNavigationMobile logo={logoMobile} links={navLinks} logoLink={logoLinkMobile} />
          <div className="hidden xl:block">
            <HeaderNavigationDesktop links={navLinks} tiles={tiles ?? []} />
          </div>
        </div>

        {/* Centro: logo */}
        <div className="flex flex-1 justify-center xl:justify-center">
          <HeaderLogo
            logo={logo}
            logoLink={logoLink}
            imageClassName="flex h-44 w-188 justify-center text-center text-16 font-bold xl:h-66 xl:w-190 md:text-28"
          />
        </div>

        {/* Derecha: utility section */}
        <div className="flex flex-1 justify-end">
          <UtilitySection
            searchElement={
              <Search categories={categories} items={searchItems} onQueryUpdate={onSearchQueryUpdate} compact />
            }
            cart={cart}
            onRemoveDiscountCode={onRemoveDiscountCode}
            onApplyDiscountCode={onApplyDiscountCode}
            isEmpty={isEmpty}
            onRemoveItem={onRemoveItem}
            onUpdateItem={onUpdateItem}
            OnMoveToWishlist={OnMoveToWishlist}
            wishlist={wishlist}
            onRemoveFromWishlist={onRemoveFromWishlist}
            onMoveToCart={onMoveToCart}
            onClearWishlist={onClearWishlist}
            totalCartItems={totalCartItems}
            totalWishlistItems={totalWishlistItems}
            emptyCartTitle={emptyCartTitle}
            emptyCartSubtitle={emptyCartSubtitle}
            emptyCartImage={emptyCartImage}
            emptyCartCategories={emptyCartCategories}
            emptyWishlistTitle={emptyWishlistTitle}
            emptyWishlistSubtitle={emptyWishlistSubtitle}
            emptyWishlistImage={emptyWishlistImage}
            emptyWishlistCategories={emptyWishlistCategories}
          />
        </div>
      </div>
    </header>
  );
};
export default Header;
